import { toast } from "react-toastify";
import { store } from "../../Redux/app/store";
import {
  setLoginUser,
  setRefreshToken,
  setResettingPassword,
  setUser,
} from "../../Redux/features/userSlice";
import api from "../baseUri";


export const SendOTP = async (username: string, navigate: any, to: string) => {
  store.dispatch(setLoginUser(true));
  const params = {
    userName: username,
  };
  await api
    .get("/Account/LogIn2FA", { params })
    .then(() => {
      toast.success("OTP sent to your email");
      store.dispatch(setLoginUser(false));
      navigate(to);
    })
    .catch((err: any) => {
      if (err?.response) toast.error(err?.response?.data);
      if (err?.message === "Network Error") toast.error(err?.message);
      store.dispatch(setLoginUser(false));
    });
};

export const loginUser = async (username: string, password: string) => {
  store.dispatch(setLoginUser(true));
  const body = {
    username,
    password,
  };
  await api
    .post("/Account/Login", body)
    .then((res) => {
      if (res.data.response?.roleId === 10 || res.data.response?.roleId === 2) {
        store.dispatch(setUser(res.data.response));
        store.dispatch(setRefreshToken(res.data.refreshToken));
      } else {
        toast.error("This role cannot login to the app");
      }
    })
    .catch((err: any) => {
      if (err?.response) toast.error(err?.response?.data);
      if (err?.message === "Network Error") toast.error(err?.message);
      store.dispatch(setLoginUser(false));
    });
};

export const loginUserWithId = async (personId: number) => {
  store.dispatch(setLoginUser(true));
  const params = {
    personId,
  };
  await api
    .get("/Account/Login", { params })
    .then((res) => {
      if (res.data.response?.roleId === 10 || res.data.response?.roleId === 2) {
        store.dispatch(setUser(res.data.response));
        store.dispatch(setRefreshToken(res.data.refreshToken));
        window.location.replace("/");
      } else {
        toast.error("This role cannot login to the app");
      }
    })
    .catch((err: any) => {
      if (err?.response) toast.error(err?.response?.data);
      if (err?.message === "Network Error") toast.error(err?.message);
      store.dispatch(setLoginUser(false));
    });
};

export const resetPassword = async (
  username: string,
  password: string,
  newPassword: string,
  otp: string
) => {
  store.dispatch(setResettingPassword(true));
  const body = {
    username,
    password,
    newPassword,
    otp
  };
  await api
    .post("Account/ForgetPassword", body)
    .then((res) => {
      store.dispatch(setResettingPassword(false));
      toast.success(`Password reset Successful`);
    })
    .catch((err: any) => {
      if (err?.response) toast.error(err?.response?.data);
      if (err?.message === "Network Error") toast.error(err?.message);
      store.dispatch(setResettingPassword(false));
    });
};
